import { axios, toQueryString} from '.'
import { useQuery, useMutation, UseQueryOptions } from '@tanstack/react-query'
import { GetDrivingDetailParams, GetDailyDrivingListParams, GetDriveSafeScoreListParams, GetDriveStaticAvgDateParams, GetGpsHistoryParams, GetHistoryCalendarParams, HistorySafeScore, HistoryDailyDriving, HistoryDrivingPath, UseHistoryRowDateDownParams} from '../types'

// 안전운행점수페이지 진입가능여부 
const getHistoryCalcuCheck = async () => await axios.main.get(`history/historyCalcuCheck`).then(res => res.data)
export const useGetHistoryCalcuCheck = (options?: object) => useQuery({
  queryKey: ["useGetHistoryCalcuCheck"],
  queryFn: getHistoryCalcuCheck,
  ...options,
  staleTime: 0,
  gcTime: 0,
})
// 운행기록 좌표상세조회
const getGpsHistory = async ({drivingId}: GetGpsHistoryParams) => await axios.main.get<HistoryDrivingPath[]>(`history/gpsHistory/${drivingId}`).then(res => res.data)
export const useGetGpsHistory = (data: GetGpsHistoryParams, options?: object) => useQuery({
  queryKey: ["useGetGpsHistory", data],
  queryFn: () => getGpsHistory(data),
  ...options,
  enabled: data.drivingId > 0,
  staleTime: 0,
  gcTime: 0,
})
// 주행평균데이터
const getDriveStaticAvgDate = async (data: GetDriveStaticAvgDateParams) => await axios.main.get(`history/driveStaticAvgDate?${toQueryString(data)}`).then(res => res.data)
export const useGetDriveStaticAvgDate = (data: GetDriveStaticAvgDateParams, options?: object) => useQuery({
  queryKey: ["useGetDriveStaticAvgDate", data],
  queryFn: () => getDriveStaticAvgDate(data),
  ...options,
  enabled: !!data.deviceId && !!data.startDate && !!data.endDate,
  staleTime: 0,
  gcTime: 0,
})
// 안전운행점수 리스트
const getDriveSafeScoreList = async (data: GetDriveSafeScoreListParams) => await axios.main.get<HistorySafeScore[]>(`history/driveSafeScoreListV2?${toQueryString(data)}`).then(res => res.data.reverse())

// 일별 주행기록 리스트 schDate: yyyy-mm-dd
const getDailyDrivingList = async (data: GetDailyDrivingListParams) => await axios.main.get<HistoryDailyDriving[]>(`history/dailyDrivingList?${toQueryString(data)}`).then(res => res.data)
export const useGetDailyDrivingList = (data: GetDailyDrivingListParams, options?: object) => useQuery({
  queryKey: ["useGetDailyDrivingList", data],
  queryFn: () => getDailyDrivingList(data),
  ...options,
  enabled: !!data.deviceId && !!data.schDate,
  staleTime: 0,
  gcTime: 0,
})
// 주행기록 상세
const getDrivingDetail = async ({drivingId}: GetDrivingDetailParams) => await axios.main.get(`history/drivingDetail/${drivingId}`).then(res => res.data)
export const useGetDrivingDetail = (data: GetDrivingDetailParams, options?: object) => useQuery({
  queryKey: ["useGetDrivingDetail", data],
  queryFn: () => getDrivingDetail(data),
  ...options,
  enabled: data.drivingId > 0,
  staleTime: 0,
  gcTime: 0,
})
// 운행정보 있는 날짜 리스트 schDate: yyyy-mm
const getHistoryCalendar = async (data: GetHistoryCalendarParams) => await axios.main.get(`history/calendar?${toQueryString(data)}`).then(res => {
  const dayIndicatorSet = new Set<string>()
  for (const i of res.data) {
    dayIndicatorSet.add(i.date)
  }
  return dayIndicatorSet
})
export const useGetHistoryCalendar = (data: GetHistoryCalendarParams, options?: object) => useQuery({
  queryKey: ["useGetHistoryCalendar", data],
  queryFn: () => getHistoryCalendar(data),
  ...options,
  enabled: !!data.deviceId && !!data.schDate,
  staleTime: 0,
  gcTime: 0,
})
// Header에서 기간선택해서 엑셀 다운로드
export const useHistoryRowDateDown = () => useMutation({
  mutationFn: (params: UseHistoryRowDateDownParams) => axios.main.get(`history/rowDateDown?${toQueryString(params)}`, {headers: {"Content-Type": "text/csv" }, responseType: "arraybuffer"}).then(res => res.data),
})